/* ============================================
   ALnoor Theme — Search & Header Interactions
   Search drawer, mobile menu, predictive search
   ============================================ */

(function () {
  'use strict';

  /* --- Search Drawer --- */
  const searchToggle = document.querySelector('.header__search-toggle');
  const searchDrawer = document.querySelector('.search-drawer');
  const searchInput = document.querySelector('.search-drawer__input');
  const searchClose = document.querySelector('.search-drawer__close');
  const searchResults = document.querySelector('[data-predictive-search-results]');

  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', () => {
      const isOpen = searchDrawer.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', isOpen);
      searchDrawer.setAttribute('aria-hidden', !isOpen);
      if (isOpen && searchInput) searchInput.focus();
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchDrawer.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchDrawer.setAttribute('aria-hidden', 'true');
        searchToggle.focus();
      });
    }

    /* Close on Escape */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) {
        searchDrawer.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchDrawer.setAttribute('aria-hidden', 'true');
        searchToggle.focus();
      }
    });
  }

  /* --- Predictive Search --- */
  if (searchInput && searchResults && window.theme?.routes?.predictiveSearch) {
    let abortController = null;

    const performSearch = debounce(async (query) => {
      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();

      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product,collection,article',
          'resources[limit]': '6'
        });

        const res = await fetch(
          `${window.theme.routes.predictiveSearch}?${params}`,
          { signal: abortController.signal }
        );

        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const results = doc.querySelector('#shopify-section-predictive-search');

        if (results) {
          searchResults.innerHTML = results.innerHTML;
        } else {
          /* Fallback: parse JSON response */
          searchResults.innerHTML = `<p class="text-muted text-small" style="padding: 0.5rem 0;">${window.theme?.translations?.noResults || 'No results found'}</p>`;
        }
      } catch (e) {
        if (e.name !== 'AbortError') console.error('Predictive search error:', e);
      }
    }, 300);

    searchInput.addEventListener('input', (e) => {
      performSearch(e.target.value.trim());
    });
  }

  /* --- Mobile Menu --- */
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuClose = document.querySelector('.mobile-menu__close');
  const overlay = document.querySelector('.header__overlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    trapFocus(mobileMenu, menuClose);
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    }
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (menuClose) menuClose.addEventListener('click', closeMobileMenu);
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu?.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  /* Mobile submenu toggles */
  document.querySelectorAll('.mobile-menu__toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const sublist = toggle.nextElementSibling;

      toggle.setAttribute('aria-expanded', !expanded);
      if (sublist) sublist.setAttribute('aria-hidden', expanded);
    });
  });

  /* --- Cart Toggle (drawer) --- */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof PubSub !== 'undefined') {
        PubSub.publish('cart:toggle');
      }
    });
  }

  /* --- Sticky header scroll behavior --- */
  const header = document.querySelector('.header--sticky');
  if (header) {
    let lastScroll = 0;
    const headerHeight = header.offsetHeight;

    window.addEventListener(
      'scroll',
      () => {
        const currentScroll = window.scrollY;

        if (currentScroll <= 0) {
          header.classList.remove('header--hidden');
          return;
        }

        if (currentScroll > lastScroll && currentScroll > headerHeight) {
          /* Scrolling down — hide */
          header.style.transform = 'translateY(-100%)';
        } else {
          /* Scrolling up — show */
          header.style.transform = 'translateY(0)';
        }

        lastScroll = currentScroll;
      },
      { passive: true }
    );

    header.style.transition = 'transform 0.3s ease';
  }
})();
